<script>
import router from "@/router";
import { layoutComputed } from "@/state/helpers";

import NavBar from "@/components/nav-bar";
import SideBar from "@/components/side-bar";
import Footer from "@/components/footer";
import {mapGetters} from "vuex";

/**
 * Vertical layout
 */
export default {
  components: { NavBar, SideBar, Footer },
  data() {
    return {
      isMenuCondensed: false,
    };
  },
  computed: {
    ...layoutComputed,
    ...mapGetters('user', ['userType', 'hasInstagramTokenError', 'hasFacebookTokenError']),
    showTokenErrorAlert() {
      return this.userType === 'influencer'
          && (this.hasFacebookTokenError || this.hasInstagramTokenError)
          && !['instagram', 'facebook'].includes(this.$route.name);
    }
  },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
  },
  methods: {
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
};
</script>

<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <NavBar />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <!-- ============================================================== -->
      <!-- Start Page Content here -->
      <!-- ============================================================== -->

      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <div v-if="showTokenErrorAlert" class="row">
              <div class="col-12">
                <b-alert
                    class="mt-3"
                    variant="danger"
                    show=""
                    dismissible
                >
                  <li v-if="hasFacebookTokenError">
                    Your facebook token expired, click <router-link tag="a" :to="`/facebook`">here</router-link> to update it.
                  </li>
                  <li v-if="hasInstagramTokenError">
                    Your instagram token expired, click <router-link tag="a" :to="`/instagram`">here</router-link> to update it.
                  </li>
                </b-alert>
              </div>
            </div>
            <slot />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  </div>
</template>

<style scoped>
.page-content {
  min-height: 100vh
}
</style>